/**
 * @fileoverview Mapa de status Meta -> rotulo/cor usado nas pills de status.
 */

export const STATUS_CONFIG = {
  APPROVED: {
    label: "Aprovado",
    dark: { bg: "rgba(16,185,129,0.14)", fg: "#6ee7b7", border: "rgba(16,185,129,0.3)" },
    light: { bg: "rgba(16,185,129,0.1)", fg: "#047857", border: "rgba(16,185,129,0.25)" },
  },
  PENDING: {
    label: "Em análise",
    dark: { bg: "rgba(245,158,11,0.14)", fg: "#fcd34d", border: "rgba(245,158,11,0.3)" },
    light: { bg: "rgba(245,158,11,0.1)", fg: "#b45309", border: "rgba(245,158,11,0.25)" },
  },
  REJECTED: {
    label: "Rejeitado",
    dark: { bg: "rgba(239,68,68,0.14)", fg: "#fca5a5", border: "rgba(239,68,68,0.3)" },
    light: { bg: "rgba(239,68,68,0.1)", fg: "#b91c1c", border: "rgba(239,68,68,0.25)" },
  },
  PAUSED: {
    label: "Pausado",
    dark: { bg: "rgba(148,163,184,0.14)", fg: "#cbd5e1", border: "rgba(148,163,184,0.25)" },
    light: { bg: "rgba(148,163,184,0.15)", fg: "#475569", border: "rgba(148,163,184,0.3)" },
  },
  DISABLED: {
    label: "Desativado",
    dark: { bg: "rgba(148,163,184,0.14)", fg: "#cbd5e1", border: "rgba(148,163,184,0.25)" },
    light: { bg: "rgba(148,163,184,0.15)", fg: "#475569", border: "rgba(148,163,184,0.3)" },
  },
  IN_APPEAL: {
    label: "Em recurso",
    dark: { bg: "rgba(168,85,247,0.14)", fg: "#d8b4fe", border: "rgba(168,85,247,0.3)" },
    light: { bg: "rgba(168,85,247,0.1)", fg: "#7e22ce", border: "rgba(168,85,247,0.25)" },
  },
};

export const CATEGORY_LABELS = {
  MARKETING: "Marketing",
  UTILITY: "Utilidade",
  AUTHENTICATION: "Autenticação",
};

export const LANGUAGE_LABELS = {
  pt_BR: "Português (Brasil)",
  en_US: "Inglês (EUA)",
  es_ES: "Espanhol",
  es_MX: "Espanhol (MX)",
  fr_FR: "Francês",
  it_IT: "Italiano",
  de_DE: "Alemão",
};

export const LANGUAGE_OPTIONS = Object.keys(LANGUAGE_LABELS);

export const getStatusStyle = (status, isDark) => {
  const cfg = STATUS_CONFIG[status];
  if (!cfg) return null;
  return isDark ? cfg.dark : cfg.light;
};

export const getStatusLabel = (status) => {
  return STATUS_CONFIG[status]?.label || status;
};

/**
 * Extrai texto do componente BODY para preview/resumo.
 */
export const getBodyText = (template) => {
  if (!template?.components) return "";
  const body = template.components.find((c) => c.type === "BODY");
  return body?.text || "";
};

/**
 * Conta variáveis {{N}} únicas no texto.
 */
export const countVariables = (text) => {
  if (!text) return 0;
  const set = new Set();
  const re = /\{\{(\d+)\}\}/g;
  let m;
  while ((m = re.exec(text)) !== null) set.add(m[1]);
  return set.size;
};
